import React, { createContext, useContext, useState } from 'react'

interface AuthState {
  isAuthenticated: boolean
  user: any
}

interface AuthContextType {
  authState: AuthState
  setAuthState: React.Dispatch<React.SetStateAction<AuthState>>
  redirectToSSOAuth: () => void
  redirectToSlackAuth: () => void
  redirectToPandaAuth: () => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    user: null,
  })

  const redirectToSSOAuth = () => {
    console.log('redirectToSSOAuth Triggered')
    const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID
    const redirectUri = import.meta.env.VITE_REDIRECT_URI
    const scope = [
      'openid',
      'https://www.googleapis.com/auth/userinfo.email',
      'https://www.googleapis.com/auth/userinfo.profile',
      // 'https://www.googleapis.com/auth/drive',
      // 'https://www.googleapis.com/auth/drive.install',
      // 'https://www.googleapis.com/auth/drive.meet.readonly',
      // 'https://www.googleapis.com/auth/drive.photos.readonly',
      // 'https://www.googleapis.com/auth/drive.readonly',
      // 'https://www.googleapis.com/auth/documents.readonly',
      // 'https://www.googleapis.com/auth/documents',
      // 'https://www.googleapis.com/auth/docs',
      // 'https://www.googleapis.com/auth/spreadsheets',
      // 'https://www.googleapis.com/auth/spreadsheets.readonly',
      // 'https://www.googleapis.com/auth/activity',
      // 'https://www.googleapis.com/auth/drive.apps',
      // 'https://www.googleapis.com/auth/tagmanager.readonly',
      'https://www.googleapis.com/auth/gmail.settings.basic',
    ].join(' ')
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?scope=${encodeURIComponent(
      scope
    )}&response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&access_type=offline&prompt=consent&state=google`
    window.location.href = authUrl
  }

  const redirectToSlackAuth = () => {
    console.log('redirectToSlackAuth Triggered')
    const slackClientId = import.meta.env.VITE_SLACK_CLIENT_ID
    const scope = 'users:read,chat:write'
    const userScope = 'users.profile:read,users:read,users:read.email'
    const slackRedirectUrl = import.meta.env.VITE_SLACK_REDIRECT_URI
    const slackAuthUrl = `https://slack.com/oauth/v2/authorize?client_id=${slackClientId}&scope=${scope}&user_scope=${userScope}&redirect_uri=${slackRedirectUrl}&state=slack`
    window.location.href = slackAuthUrl
  }

  const redirectToPandaAuth = () => {
    console.log('redirectToPandaAuth Triggered')
    const pandaClientId = import.meta.env.VITE_PANDA_CLIENT_ID
    const scope = 'read+write'
    const pandaRedirectUri = import.meta.env.VITE_PANDA_REDIRECT_URI
    const pandaAuthUrl = `https://app.pandadoc.com/oauth2/authorize?client_id=${pandaClientId}&redirect_uri=${pandaRedirectUri}&scope=${scope}&response_type=code&state=panda`
    window.location.href = pandaAuthUrl
  }

  return (
    <AuthContext.Provider
      value={{
        authState,
        setAuthState,
        redirectToSSOAuth,
        redirectToSlackAuth,
        redirectToPandaAuth,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
